<div class="w-full h-full flex flex-col bg-white">
  <!-- Mobile View Header -->
  <div class="sticky top-0 z-6 bg-white border-b border-gray-200 p-4 flex items-center justify-between">
    <button 
      (click)="closeMobileView()" 
      class="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition">
      <i class="fas fa-arrow-left"></i>
      <span class="text-sm font-semibold">Back</span>
    </button>
    <h2 class="text-lg font-bold text-gray-900">Property Details</h2>
    <div class="w-8"></div>
  </div>
  
  <!-- Mobile View Content -->
  <!-- <app-view-area [selectedItem]="selectedItem"
  [activeTab]="activeTab"
  (activeTabChange)="activeTab = $event; activeTabChange.emit($event)" class="flex-1 overflow-y-auto"></app-view-area> -->
   <app-view-area class="flex-1 pt-4 bg-[#eeeff0] overflow-y-auto" 
  [selectedItem]="selectedItem"
  [activeTab]="activeTab"
  (activeTabChange)="activeTab = $event; activeTabChange.emit($event)"
  [isMobileFullView]="true"
  (lightboxOpen)="lightboxOpen.emit($event)">
</app-view-area>
</div>